import { render, staticRenderFns } from "./CardTitle.vue?vue&type=template&id=8bdc1b88&scoped=true&"
import script from "./CardTitle.vue?vue&type=script&lang=js&"
export * from "./CardTitle.vue?vue&type=script&lang=js&"
import style0 from "./CardTitle.vue?vue&type=style&index=0&id=8bdc1b88&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bdc1b88",
  null
  
)

export default component.exports